var _rect, _rect2, _rect3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColumnOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 18.24,
    width: 4.73684,
    height: 5.76,
    fill: "#FF8800"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.63159,
    y: 18.24,
    width: 4.73684,
    height: 5.76,
    fill: "#FF8800"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.2632,
    y: 18.24,
    width: 4.73684,
    height: 5.76,
    fill: "#FF8800"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1463_15479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 12.16H5.01078L5.02128 12.1486L6.70428 10.412C6.77792 10.3419 6.83682 10.2575 6.87745 10.1637C6.91807 10.07 6.93959 9.96889 6.9407 9.8665C6.94181 9.76412 6.9225 9.66257 6.88391 9.56794C6.84533 9.47331 6.78828 9.38755 6.71617 9.31582C6.64407 9.24409 6.55841 9.18786 6.46433 9.15051C6.37025 9.11316 6.2697 9.09546 6.1687 9.09847C6.0677 9.10148 5.96835 9.12514 5.8766 9.16803C5.78485 9.21091 5.70259 9.27215 5.63478 9.34805L3.95553 11.0786C3.83328 11.2024 3.66228 11.3924 3.48753 11.5923C3.17371 11.9519 3.00049 12.4153 3.00049 12.8953C3.00049 13.3754 3.17371 13.8388 3.48753 14.1984C3.66228 14.3975 3.83328 14.5875 3.95103 14.7076L5.63478 16.4434C5.77592 16.5778 5.9629 16.6516 6.15655 16.6495C6.35021 16.6473 6.53554 16.5693 6.67373 16.4318C6.81193 16.2943 6.89229 16.108 6.89798 15.9118C6.90367 15.7157 6.83426 15.5249 6.70428 15.3794L5.05803 13.68H20.25C20.4489 13.68 20.6397 13.6 20.7804 13.4574C20.921 13.3149 21 13.1216 21 12.92C21 12.7185 20.921 12.5252 20.7804 12.3826C20.6397 12.2401 20.4489 12.16 20.25 12.16Z",
    fill: "#FF8800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 6.08003H18.9412L17.2958 7.77711C17.2221 7.84721 17.1632 7.93168 17.1226 8.02542C17.082 8.11917 17.0604 8.22027 17.0593 8.32265C17.0582 8.42503 17.0775 8.52659 17.1161 8.62122C17.1547 8.71585 17.2118 8.8016 17.2839 8.87333C17.356 8.94506 17.4416 9.00129 17.5357 9.03864C17.6298 9.07599 17.7303 9.09369 17.8313 9.09068C17.9323 9.08767 18.0317 9.06401 18.1234 9.02113C18.2152 8.97824 18.2974 8.91701 18.3652 8.84111L20.0445 7.10907C20.1667 6.98519 20.3377 6.79519 20.5125 6.59607C20.8263 6.2365 20.9995 5.77306 20.9995 5.29305C20.9995 4.81304 20.8263 4.3496 20.5125 3.99003C20.3377 3.79015 20.1667 3.60015 20.049 3.48083L18.3652 1.74803C18.2241 1.61366 18.0371 1.53982 17.8435 1.54198C17.6498 1.54414 17.4645 1.62212 17.3263 1.75961C17.1881 1.8971 17.1077 2.08343 17.102 2.27959C17.0964 2.47576 17.1658 2.66655 17.2958 2.81203L18.984 4.55243L18.99 4.56003H3.75C3.55109 4.56003 3.36032 4.6401 3.21967 4.78263C3.07902 4.92516 3 5.11846 3 5.32003C3 5.52159 3.07902 5.7149 3.21967 5.85743C3.36032 5.99996 3.55109 6.08003 3.75 6.08003Z",
    fill: "#FF8800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1463_15479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.24,
    fill: "white",
    transform: "translate(3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnOrder);
export default __webpack_public_path__ + "static/media/columnOrder.147817265e3f67f81e691d29c221755b.svg";
export { ForwardRef as ReactComponent };